export const ProfileFieldsDowngrade = {
  bindings: {
    hasError: '<',
    message: '<',
    form: '<',
    subscription: '<',
    products: '<',
    onSubmit: '&',
    onCancel: '&',
  },

  template: `
    <div class="profile-cancel">
      <div class="row">
        <div class="col-md-4">
          <h5>Modify Subscription</h5>
          <p>
            To modify your subscription, please select the product you would
            like to change to.
          </p>
        </div>
        <div class="col-md-8">
          <alert type="danger" ng-show="$ctrl.hasError">
            {{ $ctrl.message }}
          </alert>
          <form-group-row>
            <form-group-left>
              <form-label for="productId">
                Modify to:
              </form-label>
            </form-group-left>
            <form-group-right>
              <form-select
                form="$ctrl.form"
                name="voomeProductId"
                required="true"
                errors="{ required: 'This is a required field.' }"
                on-update="$ctrl.onUpdate(key, value)">
                <option value="">-- Select a product --</option>
                <option
                  value="{{ product.id }}"
                  ng-repeat="product in $ctrl.products track by $index">
                  {{ product.name }} - <signup-price value="product.totalInCents"></signup-price>
                </option>
              </form-select>
              <p class="mt-3 text-danger"
                ng-show="$ctrl.downgradeProduct">
                On submitting you will no longer be able to access
                {{ $ctrl.downgradeProduct.name }}.
              </p>
            </form-group-right>
          </form-group-row>
        </div>
      </div>
    </div>`,

  controller() {
    return {
      onUpdate(key, value) {
        const downgradeProducts = this.products.filter(
          item => item.id !== parseInt(value, 10)
        );

        this.downgradeProduct = downgradeProducts.length
          ? downgradeProducts[0]
          : undefined;
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileFieldsDowngrade.js